import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './Button';
import { MessageCircle } from 'lucide-react';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      // Show button when page is scrolled down 600px
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  return <AnimatePresence data-id="element-168">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-6 left-0 right-0 z-50 flex justify-center px-4 pointer-events-none" data-id="element-169">
          <div className="pointer-events-auto shadow-2xl rounded-full" data-id="element-170">
            <Button href="#comprar" className="px-6 py-3 text-base shadow-lg flex items-center gap-2" data-id="element-171">
              <MessageCircle size={20} data-id="element-172" />
              <span data-id="element-173">Quiero volver a mi centro</span>
            </Button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}